import { Component, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Join from "@/pages/Join";
import Play from "@/pages/Play";
import TV from "@/pages/TV";
import VenueDashboard from "@/pages/VenueDashboard";
import Poster from "@/pages/Poster";
import AuthCallback from "@/pages/AuthCallback";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen bg-navy-900 flex items-center justify-center p-8">
          <div className="max-w-md text-center">
            <h1 className="font-display text-3xl font-extrabold text-amber mb-3">Stage lights flickered</h1>
            <p className="text-mut mb-6">Something went wrong rendering this view.</p>
            <button
              data-testid="error-reload-button"
              onClick={() => window.location.reload()}
              className="rounded-full bg-amber text-navy-900 font-bold px-8 py-3"
            >
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/join" element={<Join />} />
          <Route path="/play/:code" element={<Play />} />
          <Route path="/tv/:code" element={<TV />} />
          <Route path="/tv" element={<TV />} />
          <Route path="/venue" element={<VenueDashboard />} />
          <Route path="/poster/:code" element={<Poster />} />
          <Route path="/auth" element={<AuthCallback />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster theme="dark" position="top-center" />
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
